import { Component, OnInit } from "@angular/core";
import { TaskService } from "../../task.service";
import { UtilsService } from "../../../../auth/service/utils.service";
import { AuthenticationService } from "../../../../auth/service";
import { RoleService } from "../../../../auth/service/role.service";
import { GroupsService } from "../../../../auth/service/group.service";
import { Router } from "@angular/router";
import { IRole } from "app/auth/models";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";

@Component({
  selector: "app-all-todo-list",
  templateUrl: "./all-todo-list.component.html",
  styleUrls: ["./all-todo-list.component.scss"]
})
export class AllTodoListComponent implements OnInit {
  public tasks: any = [];
  public contentHeader: IContentHeader = null;
  public searchKey: string = "";
  public filterTasks: any = [];
  public tableLimit: number = 10;
  public filter_status: number = -1;
  public filter_priority: number = -1;
  public filter_role: number = -1;
  public filter_group: number = -1;
  public status: any = [0, 1, 2];
  public priorities: any = [0, 1, 2];
  public roles: IRole[] = [];
  public groups: any = [];

  constructor(
    public _taskService: TaskService,
    public _authenticationService: AuthenticationService,
    public _utilService: UtilsService,
    public _roleService: RoleService,
    public _groupService: GroupsService,
    public _router: Router
  ) {
    this.contentHeader = {
      headerTitle: "MENU.TASK_LIST",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: false,
            link: "/"
          },
          {
            name: "TITLES.MANAGE",
            isLink: true,
            link: "/dashboard/platform-management"
          },
          {
            name: "MENU.TASK_LIST",
            isLink: false
          }
        ]
      }
    };
  }

  async ngOnInit() {
    if (!this._authenticationService.hasCapability("task_view_others")) {
      await this._router.navigateByUrl("/dashboard/main");
      return false;
    }
    this.tasks = await this._taskService.all()
      .then((tasks: any) => tasks.map((task: any) => ({ ...task, users_names: task.users.filter((user: any) => user.hash).map((user: any) => user.complete_name).join(", ") })));
    await this.searchTask();
    this.roles = await this._roleService.getList();
    this.groups = await this._groupService.getList();
  }

  async searchTask() {
    const key: string = this.searchKey.trim().toLowerCase();
    let filteredTasks: any = this.tasks;
    if (key.length > 0) {
      filteredTasks = filteredTasks.filter((item: any) => {
        return item.title.toLowerCase().includes(key) || item.description.toLowerCase().includes(key);
      });
    }
    if (this.filter_status > -1) {
      filteredTasks = filteredTasks.filter((item: any) => Number(item.status) === Number(this.filter_status));
    }
    if (this.filter_priority > -1) {
      filteredTasks = filteredTasks.filter((item: any) => Number(item.priority) === Number(this.filter_priority));
    }
    if (this.filter_role > -1) {
      filteredTasks = filteredTasks.filter((item: any) => Number(item.role) === Number(this.filter_role));
    }
    if (this.filter_group > -1) {
      filteredTasks = filteredTasks.filter((item: any) => Number(item.group) === Number(this.filter_group));
    }

    this.filterTasks = filteredTasks;
  }

  updateTableLimit(event: { target: { value: string } }) {
    this.tableLimit = Number(event.target.value);
  }
}
